// extracted by mini-css-extract-plugin
module.exports = {"slide":"plans_slide_2n0H0","slide-reverse":"plans_slide-reverse_3IYXn","title":"plans_title_3VVHI","centered-container-subscription":"plans_centered-container-subscription_3Zj3w"};